<template>
  <div :class="$style.breadcrumbs">
    <div :class="$style.path">
      <span v-if="activeItem">
        <strong>{{ $t(activeItem, '') }}</strong>
      </span>
    </div>
  </div>
</template>

<script>
import { getLeftMenuData } from '@/services/menu'
import { reduce } from 'lodash'

export default {
  name: 'breadcrumbs',
  data() {
    return {
      breadcrumb: [],
      activeItem: {},
      path: [],
    }
  },
  props: {
  },
  computed: {
    menuData() {
      return getLeftMenuData
    },
  },
  methods: {
    update() {
      const part = this.$route.path.split("/")
            part.push('title')
      let path = []
      part.forEach(p => {
        path.push(p)
        if ( !this.$te(path.join(".")) ) path.pop()
      })
      this.activeItem = path.join(".")
    },
  },
  mounted: function () {
    this.update()
  },
  watch: {
    $route(to) {
      this.update()
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
